import { SubscriptionPlan } from '../types/subscription';

const SUBSCRIPTION_STORAGE_KEY = 'gameshub_subscription';

export interface StoredSubscription {
  msisdn: string;
  planId: string;
  planName: string;
  durationDays: number;
  subscribedAt: number;
  expiresAt: number;
}

export const saveSubscription = (
  plan: SubscriptionPlan,
  msisdn: string
): StoredSubscription => {
  const subscribedAt = Date.now();
  const expiresAt = subscribedAt + plan.durationDays * 24 * 60 * 60 * 1000;

  const subscription: StoredSubscription = {
    msisdn,
    planId: plan.id,
    planName: plan.name,
    durationDays: plan.durationDays,
    subscribedAt,
    expiresAt,
  };

  localStorage.setItem(SUBSCRIPTION_STORAGE_KEY, JSON.stringify(subscription));
  return subscription;
};

export const loadSubscription = (): StoredSubscription | null => {
  try {
    const raw = localStorage.getItem(SUBSCRIPTION_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw) as StoredSubscription;
  } catch {
    return null;
  }
};

export const clearSubscription = (): void => {
  localStorage.removeItem(SUBSCRIPTION_STORAGE_KEY);
};

export const isSubscriptionActive = (
  subscription: StoredSubscription | null = loadSubscription()
): boolean => {
  if (!subscription) {
    return false;
  }

  if (subscription.expiresAt <= Date.now()) {
    clearSubscription();
    return false;
  }

  return true;
};

export const getActiveSubscription = (): StoredSubscription | null => {
  const subscription = loadSubscription();
  return isSubscriptionActive(subscription) ? subscription : null;
};
